import styled from 'styled-components';

export const SimilarVideoContainer = styled.section`
  margin: 30px 0;

  @media (max-width: 720px) {
    padding: 0 10px;
  }
`;

export const SimilarVideoSection = styled.div`
  display: flex;
  justify-content: center;
  column-gap: 20px;
  flex-wrap: ${(props) => (props.readMoreMylo ? 'nowrap' : 'wrap')};
  flex-direction: column;
  padding: 0 20px;
  @media (min-width: 768px) {
    flex-direction: row;
    padding-left: ${(props) => (props.stroller ? '20px' : '0')};
  }
`;

export const SimilarVideosCard = styled.div`
  flex-basis: ${(props) => (props.readMoreMylo ? 'auto' : '31%')};
  flex-shrink: ${(props) => (props.readMoreMylo ? '1' : '0')};
  width: 100%;
  margin: ${(props) =>
    props.babyNamesArticle
      ? '20px 16px 20px 4px'
      : props.searchArticle
        ? '0 30px 20px 4px'
        : '20px 0'};
  position: relative;
  overflow: hidden;

  transition:
    all 0.3s cubic-bezier(0.155, 1.105, 0.295, 1.12) 0s,
    box-shadow 0.3s ease 0s;
  &:hover {
    transform: scale(1.03);
  }
  @media (max-width: 720px) {
    display: flex;
    justify-content: space-between;
    column-gap: 14px;
    align-items: center;
    justify-content: space-between;
  }

  &.lowOpacity {
    opacity: 0.5;
  }

  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: rippleB 450ms linear;
    background-color: rgba(255, 255, 255, 0.7);
  }

  @keyframes rippleB {
    to {
      transform: scale(2);
      opacity: 0;
    }
  }
`;

export const SimilarVideoTitle = styled.h2`
  color: rgba(0, 0, 0, 0.8);
  font-size: clamp(20px, 2vw, 24px);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: ${(props) => (props.hindiArticle ? '0.23px' : '4.23px')};
  text-align: center;
  padding-bottom: 10px;
`;

export const MostReadArticle = styled.h3`
  font-size: clamp(14px, 2vw, 16px);
  color: rgba(0, 0, 0, 0.54);
  font-weight: 500;
  letter-spacing: 3.23px;
  text-align: center;
  padding: 8px 0;
`;
export const SimilarVideoThumbnail = styled.div`
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  aspect-ratio: 16/8;
`;

export const SimilarVideoThumbnailImg = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 4px;
  filter: brightness(0.95);
  object-fit: ${(props) => (props.videoImage ? 'cover' : 'inherit')};

  @media (max-width: 720px) {
    width: 140px;
    max-height: 70px;
  }
`;
export const SimilarVideoThumbnailDiv = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 4px;
  filter: brightness(0.95);
  object-fit: ${(props) => (props.videoImage ? 'cover' : 'inherit')};

  @media (max-width: 720px) {
    width: 140px;
    max-height: 70px;
  }
`;

export const PlayButton = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: translate(-50%, -50%) scale(1.14);
  }
  span {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: hsl(0deg, 0%, 0%, 58%);
    position: relative;
    display: inline-block;

    @media (max-width: 720px) {
      width: 36px;
      height: 36px;
    }

    img {
      position: absolute;
      top: 55%;
      left: 55%;
      transform: translate(-50%, -50%);
      width: 40px;
      height: 40px;

      @media (max-width: 720px) {
        width: 26px;
        height: 26px;
      }
    }
  }
`;

export const VideoTitle = styled.h4`
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 48%);
  text-transform: uppercase;
  padding-top: 5px;

  @media (max-width: 720px) {
    padding-top: 0;
    font-size: 12px;
  }
`;

export const Content = styled.p`
  font-size: 14px;
  color: hsl(0deg, 0%, 0%, 87%);
  font-weight: 500;
  margin: 5px 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  @media (max-width: 720px) {
    -webkit-line-clamp: 3;
  }
`;

export const Views = styled.p`
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  color: #787878;
  height: 15.2px;
`;

export const VideoDescriptionContainer = styled.div`
  margin-top: 8px;

  @media (max-width: 720px) {
    margin-top: 0;
    order: -1;
  }
`;

export const FixedWithHeightDiv = styled.div`
  height: 80vh;
  width: 100%;
`;
